<template>
    <v-dialog @input="(!$event)? $payments.undone.show = false : null" :width="($vuetify.breakpoint.mdAndUp)? '70%' : '95%'" :value="$payments.undone.show">
        <v-card>
            <v-card-title>{{$t('Payments to Visual Impression')}}</v-card-title>
            <v-card-text>
                <v-data-table v-if="items" :headers="headers" :items="items">
                    <template v-slot:item.link="{item}">
                        <a class="default-link" :href="item.data[0].link">Link</a>
                    </template>
                    <template v-slot:item.amount="{item}">
                        <span>{{calcAmount(item.data) | currency()}}</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        data:() => {
            return{
                headers:[
                    {
                        text: 'Link',
                        value: 'link',
                        sortable:false
                    },
                    {
                        text: 'Total amount',
                        value: 'amount',
                        sortable:false
                    }
                ]
            }
        },
        computed:{
            items(){
                if(!this.$payments.undone.data || !this.$payments.undone.data.links) return [];
                var data = [];
                for (var i in this.$payments.undone.data.links){
                    data.push({
                        hash: i,
                        data: this.$payments.undone.data.links[i]
                    });
                }
                return data;
            }
        },
        methods:{
            calcAmount(items){
                var tmp = 0;
                items.forEach(item => {
                    tmp = tmp + item.amount_for_vi;
                })
                return tmp;
            }
        }
    }
</script>
